import Badge from "ds/components/Badge";
import { BadgeVariants } from "ds/components/Badge/types";
import { EntityChangeResult } from "types/generated";

type EntityChangeResultConfig = {
  variant: BadgeVariants;
  text: string;
};

/** @public (Knip ignored - used in the file and exported for stories) */
export const ENTITY_CHANGE_RESULTS: Record<EntityChangeResult, EntityChangeResultConfig> = {
  [EntityChangeResult.Failed]: { variant: "red", text: "Failed" },
  [EntityChangeResult.Partial]: { variant: "yellow", text: "Partial" },
  [EntityChangeResult.Successful]: { variant: "green", text: "Successful" },
  [EntityChangeResult.Unknown]: { variant: "gray", text: "Unknown" },
  [EntityChangeResult.Planned]: { variant: "blue", text: "Planned" },
  [EntityChangeResult.Unplanned]: { variant: "blue", text: "Unplanned" },
};

type EntityChangeResultBadgeProps = {
  type: EntityChangeResult;
  className?: string;
};

const EntityChangeResultBadge = ({ type, className }: EntityChangeResultBadgeProps) => {
  return (
    <Badge
      variant={ENTITY_CHANGE_RESULTS[type].variant}
      type="strong"
      className={className}
      text={ENTITY_CHANGE_RESULTS[type].text}
    />
  );
};

export default EntityChangeResultBadge;
